import * as Contentful from 'contentful'
import Store from '../store';

let host = process.env.host
let accessToken = process.env.accessToken

const contentfulClient = Contentful.createClient({
	space: 'h3h51dttsgxr',
    insecure: false,
    host: host,
    accessToken: accessToken
})

export const getContent = function() {
    return new Promise(resolve => {
        if (!Store.getters['ui/isContentLoaded'] || Store.getters['projects/list'].length === 0) {
            contentfulClient.getEntries()
                .then(data => {
                    data.items.forEach(item => {
                        switch (item.sys.contentType.sys.id) {
                            case 'project':
                                const project = JSON.parse(JSON.stringify(item))
                                Store.dispatch('projects/addProject', project)
                                break
                            case 'page':
                                const page = JSON.parse(JSON.stringify(item))
                                Store.dispatch('pages/addPage', page)
                                break
                        }
                    })
                    Store.dispatch('ui/contentIsLoaded')
                    resolve()
                })
        } else {
            resolve()
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/Contentful.js